import React from "react";
import { Calendar as CalendarIcon, X } from "lucide-react";

const EventModalHeader = ({
  isEditing,
  isOriginator,
  formData,
  eventTypes,
  eventType,
  t,
  language,
  styles,
  screenSize,
  getShortName,
  onClose,
  handleButtonHover,
}) => {
  return (
    <div style={styles.modalHeader}>
      <div style={styles.modalTitleSection}>
        <div style={styles.modalIcon}>
          <CalendarIcon size={screenSize.isMobile ? 24 : 28} />
        </div>
        <div>
          <h2 style={styles.modalTitle}>
            {isEditing
              ? isOriginator
                ? t.editEvent
                : t.viewEventDetails
              : t.createNewEvent}
          </h2>
          <p style={styles.modalSubtitle}>
            {isEditing &&
            !isOriginator &&
            formData.originatorName &&
            formData.originatorName !== t.unknownUser
              ? `${t.eventOrganizedBy} ${getShortName(
                  formData.originatorName,
                  2
                )} (${t.organizer})`
              : isEditing
              ? t.updateEventDetails
              : `${t.addNewEvent} ${
                  eventTypes
                    .find((type) => type.id === eventType)
                    ?.name?.toLowerCase() ||
                  (language === "ar" ? "حدث" : "event")
                } ${t.toYourCalendar}`}
          </p>
        </div>
      </div>
      <button
        style={styles.closeButton}
        onClick={onClose}
        onMouseEnter={(e) => handleButtonHover(e, true)}
        onMouseLeave={(e) => handleButtonHover(e, false)}
      >
        <X size={screenSize.isMobile ? 20 : 24} />
      </button>
    </div>
  );
};

export default EventModalHeader;
